import PageNamePageValueObject from './PageNamePageValueObject.js'
import UrlValueObject from './UrlValueObject.js'

export default class PageValueObjectsFactory {
  static pageNamePageValueObject = ({pageName}) => {
    return new PageNamePageValueObject({pageName})
  }

  static urlValueObject = ({url, invalidUrlErrorFactory}) => new UrlValueObject({url})
}
